//
//
//
//
//
//
//
//
//
//
//
//
//
//

import stickybits from "stickybits";
import HeaderCell from "./header/HeaderCell";
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "MatrixHeader",
  props: ["cols"],
  components: {
    matrixHeaderCell: HeaderCell
  },
  data() {
    return {
      sticky: null
    };
  },
  computed: {
    ...mapGetters(["computed", "filters", "authorized"]),
    top() {
      return document.querySelector(".headerMain")
        ? document.querySelector(".headerMain").offsetHeight
        : 0;
    }
  },
  methods: {
    ...mapActions(["save"]),
    async doSave() {
      let id = document.querySelector("#tableId").value;
      await this.save(id);
    }
  },
  mounted() {
    let media = window.matchMedia("(min-width: 1100px)");
    media.addListener(e => {
      if (e.matches) {
        this.sticky = stickybits(this.$el, {
          useStickyClasses: true,
          stickyBitStickyOffset: this.top
        });
      } else {
        if (this.sticky) {
          this.sticky.cleanup();
        }
      }
    });
    if (media.matches) {
      this.sticky = stickybits(this.$el, {
        useStickyClasses: true,
        stickyBitStickyOffset: this.top
      });
    }
  }
};
